import React from 'react'
import './note.css'

export default function Note() {
  return (
    <section className='cardSection glass'>
        <div className='card glass'>
            <p className='altMont'>“I just exist and I'm living my existence in the world.”</p>
            <p className='mont'>Yvonne Amaria O.</p>
        </div>
    </section>
  )
}
